var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.425,
    height: 13.497,
    viewBox: "0 0 15.425 13.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-wallet",
    "data-name": "Icon awesome-wallet",
    d: "M13.895,5.142H2.41a.482.482,0,0,1,0-.964H13.979a.482.482,0,0,0,.482-.482A1.446,1.446,0,0,0,13.015,2.25H1.928A1.928,1.928,0,0,0,0,4.178v9.641a1.928,1.928,0,0,0,1.928,1.928H13.895a1.492,1.492,0,0,0,1.53-1.446V6.588A1.492,1.492,0,0,0,13.895,5.142Zm-1.362,6.266a.964.964,0,1,1,.964-.964A.964.964,0,0,1,12.533,11.409Z",
    transform: "translate(0 -2.25)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWallet);
export default __webpack_public_path__ + "static/media/IconWallet.409c4c82771830f18b4e06031def865d.svg";
export { ForwardRef as ReactComponent };